<template>
	<div class="pageContainer app-container">
		<el-row class="flexStart">
			<el-select v-model="searchForm.ktype" size="small" placeholder="请选择" style="width: 150px;">
				
				<el-option label="学生姓名" value="stu_name">学生姓名</el-option>
				<el-option label="报道须知号" value="fee_idx">报道须知号</el-option>
			</el-select>

			<el-input v-model="searchForm.keyword" size="small" placeholder="请输入"
				style="max-width: 200px;margin-right: 10px; margin-left: 10px;" />

			<el-select v-model="searchForm.pjson" size="small" placeholder="请选择"
				style="width: 130px; margin-right: 10px;">

				<el-option label="全部" value="all">全部</el-option>
				<el-option label="未量" :value="0">未量</el-option>
				<el-option label="已量" :value="1">已量</el-option>


			</el-select>
			<el-button size="small" icon="el-icon-search" @click="onSearch" plain type="primary">查询</el-button>
			<el-button size="small" icon="el-icon-refresh" @click="onSearch" plain type="primary">刷新</el-button>

		</el-row>

		<el-row type="flex" :gutter="16" style="margin-top: 20px">
			<el-col :span="8" v-if="false">
				<div class="treeContainer">
					<div class="treeTitle">系部专业</div>
					<el-tree :data="treeData" :props="treeProps" :default-expand-all="true"
						:expand-on-click-node="false" @node-click="handleNodeClick">
					</el-tree>
				</div>
			</el-col>
			<el-col :span="24" class="tabContainer">
				<el-tabs v-model="activeName" type="border-card" style="height: 100%;">
					<el-tab-pane label="量校服学生列表" name="lxf">
						<el-table stripe :data="tableData" size="mini"
							style="width: 100%;margin-bottom: 20px; color: #000;" border>

							<el-table-column type="index" width="60" label="序号">
								<template slot-scope="scope">
									<span>{{scope.$index+1+(page.pageIndex-1)*page.pageSize}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="stu_name" label="姓名" width="100"></el-table-column>
							<el-table-column prop="fee_idx" label="报道须知号" width="100">
								<template slot-scope="scope">
									{{get4Num(scope.row.fee_idx)}}
								</template>
							</el-table-column>
							<el-table-column prop="archive" label="建档号" width="120"></el-table-column>
							<el-table-column prop="exam_num" label="考试证号" width="120"></el-table-column>
							<el-table-column prop="exam_score" label="总分" width="60"></el-table-column>
							<el-table-column prop="gender" label="性别" width="60">
								<template slot-scope="scope">
							
									<span v-if="scope.row.gender==1">男</span>
									<span v-if="scope.row.gender==2">女</span>
							
									<span v-if="scope.row.gender==0">未知</span>
								</template>
							</el-table-column>
							<el-table-column prop="graduate_sch_city" label="地区" width="150">
								<template slot-scope="scope">
											
									{{getCity(scope.row.graduate_sch_city)}}
								</template>
							</el-table-column>
							<el-table-column prop="major_name" label="专业" min-width="140"></el-table-column>
							<el-table-column prop="phone" label="联系方式"  min-width="120"></el-table-column>
							<el-table-column prop="status" label="状态" width="80">
								<template slot-scope="scope">
									<span v-if="scope.row.pjson" style="color: green;">已量</span>
									<span v-else style="color: orangered;">未量</span>
							
								</template>
							</el-table-column>

							<el-table-column fixed="right" label="操作" width="140">
								<template slot-scope="scope">
									<!-- <el-popconfirm width="200" confirmButtonText='确定' cancelButtonText='取消' icon="el-icon-info" iconColor="red"
									 @confirm="handleDel(scope.row)" placement="left" title="是否确定删除？">
										<a slot="reference" size="small" style="color: red;font-size: 12px;margin-right: 10px;">删除</a>
									</el-popconfirm> -->
									<el-button @click="handleModify(scope.row)" type="text" size="small">量校服</el-button>



								</template>
							</el-table-column>
						</el-table>
						<el-pagination @current-change="handlePageChange" :current-page="page.pageIndex"
							:page-size="page.pageSize" :total="page.total" @size-change="handleSizeChange"
							:page-sizes="page.pageSizes" layout="total, prev, pager, next, sizes, jumper">
						</el-pagination>
					</el-tab-pane>
				</el-tabs>
			</el-col>
		</el-row>
		<el-dialog title="学生信息" width="800px" :visible.sync="dialogDetail" :close-on-click-modal="false">

			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<span>学生基础信息</span>

				</div>
				<div>

					<el-form :model="formData" inline ref="adminUserInfo" label-width="120px">

						<el-col :span="12">
							<el-form-item label="姓名:" prop="archive">
								{{formData.stu_name}}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="性别:" prop="archive">
								{{formData.gender==1?'男':'女'}}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="专业:" prop="archive">
								{{formData.major_name}}
							</el-form-item>
						</el-col>
						
						<el-col :span="12">
							<el-form-item label="报道须知号:" prop="archive">
								{{get4Num(formData.fee_idx)}}
							</el-form-item>
						</el-col>




					</el-form>


				</div>
			</el-card>


			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<span>校服信息</span>

				</div>

				<div>
					<table class="datatable" cell-spacing="1" cell-padding="10">
						<tr>
							<th style="width: 10%;">型号</th>
							<th style="width: 10%;">M</th>
							<th style="width: 10%;">L</th>
							<th style="width: 10%;">XL</th>
							<th style="width: 10%;">2XL</th>
							<th style="width: 10%;">3XL</th>
							<th style="width: 10%;">4XL</th>
							<th style="width: 10%;">5XL</th>
							<th style="width: 10%;">6XL</th>
							<th style="width: 10%;">其他</th>

						</tr>
						<tr>
							<td>建议身高</td>
							<td>150-155</td>
							<td>155-160</td>
							<td>160-165</td>
							<td>165-170</td>
							<td>170-175</td>
							<td>175-180</td>
							<td>180-185</td>
							<td>185-190</td>
							<td>特殊体型</td>
						</tr>
						<tr>
							<td>体重(kg)</td>
							<td>45-50</td>
							<td>50-55</td>
							<td>55-60</td>
							<td>60-65</td>
							<td>65-70</td>
							<td>70-75</td>
							<td>75-80</td>
							<td>80-85</td>
							<td>特殊体型</td>
						</tr>
						<tr style="cursor: pointer;">
							<td>选择</td>
							<td style="font-size: 30px; color: orangered;" @click="xiaofu.size='M'">
								<i class="el-icon-success" v-if="xiaofu.size=='M'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="xiaofu.size='L'">
								<i class="el-icon-success" v-if="xiaofu.size=='L'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="xiaofu.size='XL'">
								<i class="el-icon-success" v-if="xiaofu.size=='XL'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="xiaofu.size='2XL'">
								<i class="el-icon-success" v-if="xiaofu.size=='2XL'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="xiaofu.size='3XL'">
								<i class="el-icon-success" v-if="xiaofu.size=='3XL'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="xiaofu.size='4XL'">
								<i class="el-icon-success" v-if="xiaofu.size=='4XL'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="xiaofu.size='5XL'">
								<i class="el-icon-success" v-if="xiaofu.size=='5XL'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="xiaofu.size='6XL'">
								<i class="el-icon-success" v-if="xiaofu.size=='6XL'"></i>
							</td>
							<td style="font-size: 30px; color: orangered;" @click="xiaofu.size='O'">
								<i class="el-icon-success" v-if="xiaofu.size=='O'"></i>
							</td>
						</tr>
					</table>
					<div style="padding: 20px 0;">


						<el-input type="text" v-model="xiaofu.remark" size="small" placeholder="体型说明或备注"></el-input>
					</div>
				</div>

			</el-card>

			<el-row class="flexEnd">

				<el-button size="small" type="default" style="margin-top: 20px;" icon="el-icon-circle-close"
					@click="dialogDetail=false">关闭</el-button>
				<el-button size="small" type="primary" style="margin-top: 20px;" icon="el-icon-circle-check"
					@click="saveForm">保存</el-button>

			</el-row>



		</el-dialog>
	</div>
</template>
<script>
	import api from '@/api/api';

	export default {
		name: 'Student',
		data() {
			return {
				searchForm: {
					ktype: 'stu_name',
					status: 1,
					pjson: 0
				}, //查询

				activeName: 'lxf',
				tableData: [],
				page: {
					pageIndex: 1,
					pageSize: 20,
					pageSizes: [20, 50],
					total: 0
				},
				dialogDetail: false,
				formData: {},
				xiaofu: {
					size: "",
					remark: ""
				},
				xiaofuData: [

				]
			}
		},

		mounted() {
			this.getList();

		},
		methods: {

			//table
			getList() {
				let params = {
					page: this.page.pageIndex,
					pagesize: this.page.pageSize,
					status: this.searchForm.status,
					stu_type: 'all',
					list_type: 2,
					pjson: this.searchForm.pjson,
					orderby:"fee_idx asc"
				}
				params.ktype = this.searchForm.ktype;
				params.keyword = this.searchForm.keyword;

				this.$http.post(api.stuList, params).then(res => {
					for (let item of res.data.data) {
						let city = item.graduate_sch_city.split(",")
						if (city.length >= 3) {
							item.city = city[1]
						}
					}
					this.tableData = res.data.data
					this.page.total = res.data.page.count
				})
			},
			handleNodeClick(data) {
				this.deptId = data.id
				// this.tabMapOptions[0].label=`${data.title}`
				this.getList()
			},

			handleModify(row) {


				try {
					this.xiaofu = JSON.parse(row.pjson)
				} catch (e) {
					this.xiaofu = {
						size: "",
						remark: ""
					}
				}
				if(!this.xiaofu){
					this.xiaofu = {
						size: "",
						remark: ""
					}
				}
				this.formData = row;
				this.dialogDetail = true

			},
			handleDel(row) {
				this.$http.post(api.stuDel, {
					ids: String(row.id)
				}).then(res => {
					this.$message.success('删除成功')
					this.getList();
				})
			},
			handlePageChange(e) {
				this.page.pageIndex = e
				this.getList()
			},
			handleSizeChange(e) {
				this.page.pageSize = e
				this.getList()
			},
			handleSelectionChange(val) {
				let _this = this;
				_this.multipleSelection = val;
			},
			multSp() {
				if (this.multipleSelection.length > 0) {

					let stuid = this.multipleSelection.map(e => {
						return e.id
					}).join(",")
					console.log(stuid)
					this.$confirm('确认审批通过?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$http.post("/api/t_sch_student_sp", {
							ids: stuid,
							status: window.pmid == 4 ? 3 : 2 //南财跳过确认
						}).then(res => {
							this.getList()
							this.$message({
								type: 'success',
								offset: 500,
								message: '审批成功'
							});
						})


					}).catch(() => {

					});




				} else {
					this.$message({
						type: 'error',
						offset: 500,
						message: '请选择学生'
					});

				}
			},
			showForm() {
				this.$refs.visiable_form.show()
			},
			saveForm(e) {
				if (this.xiaofu.size) {
					this.$http.post("/api/xiaofu_save", {
						id: this.formData.id,
						pjson: this.xiaofu
					}).then(res => {
						this.$message.success(this.formData.stu_name + '-校服尺寸保存成功！')
						this.getList();
						this.dialogDetail = false

					})
				} else {
					this.$message.warning("未选择校服尺寸")
				}


			},
			onSearch() {
				this.tableData = [];
				this.page.pageIndex = 1;
				this.getList();
			},
			onReset() {
				this.searchForm = {
					ktype: 'stu_name'
				};
				this.tableData = [];
				this.page.pageIndex = 1;
				this.getList();
			},
			handleSelectionChange(val) {
				let _this = this;
				_this.multipleSelection = val;
			},
			mutiDel() {
				let ids = ''
				if (this.multipleSelection && this.multipleSelection.length > 0) {
					ids = this.multipleSelection.map((item, index) => {
						return item.id
					}).join(',')
					this.handleDel({
						id: ids
					})
				} else {
					this.$message.warning('请至少选择一条数据')
				}
			},
		}
	}
</script>

<style scoped lang="less" type="text/less">
	.app-container {
        .treeContainer {
            height: 100%;
            background-color: #fff;
            box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
            border: 1px solid  rgba(220,223,230,0.6);
            
            .treeTitle {
                height: 40px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #409eff;
                padding-left: 6px;
            }
        }
    }
	
</style>
